export const muiAccordionDetailsTheme = {
  MuiAccordionDetails: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(0.5, 3, 2),
      }),
    },
  },
};
